module.exports = __webpack_public_path__ + "static/img/nullMonitor.bfa53e0f.png";